import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/verification`;
const OFP_BASE = `${API_BASE_URL}/api/ofp`;

export const verificationService = {
  // Get OFP products for PCF calculation dropdown
  async getOFPProducts() {
    const response = await axios.get(`${OFP_BASE}/products`);
    return response.data;
  },

  async startVerification(entityType, entityIds, options = {}) {
    const response = await axios.post(`${API_BASE}/start`, { entityType, entityIds, options });
    return response.data;
  },

  async getSessions(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.entityType) params.append('entityType', filters.entityType);
    if (filters.limit) params.append('limit', filters.limit);
    const query = params.toString();
    const response = await axios.get(`${API_BASE}/sessions${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getSession(sessionId) {
    const response = await axios.get(`${API_BASE}/sessions/${sessionId}`);
    return response.data;
  },

  async getSessionResults(sessionId) {
    const response = await axios.get(`${API_BASE}/sessions/${sessionId}/results`);
    return response.data;
  },

  async processResults(sessionId) {
    const response = await axios.post(`${API_BASE}/sessions/${sessionId}/process`);
    return response.data;
  },

  async checkDVEHealth() {
    const response = await axios.get(`${API_BASE}/dve-health`);
    return response.data;
  },

  async reVerifySession(sessionId, options = {}) {
    const response = await axios.post(`${API_BASE}/sessions/${sessionId}/re-verify`, { options });
    return response.data;
  },

  async generateTestData(count = 3, emissionType = 'all') {
    const response = await axios.post(`${API_BASE}/generate-test-data`, { count, emissionType });
    return response.data;
  },

  // PCF Verification Methods
  async startPCFVerification(eLedgerId, options = {}) {
    const response = await axios.post(`${API_BASE}/pcf`, {
      eLedgerId,
      ...options
    });
    return response.data;
  },

  async getPCFVerificationStatus(sessionId) {
    const response = await axios.get(`${API_BASE}/pcf/${sessionId}`);
    return response.data;
  },

  async getPCFCalculationsForLedger(eLedgerId) {
    const response = await axios.get(`${API_BASE}/pcf/ledger/${eLedgerId}`);
    return response.data;
  }
};

export default verificationService;
